module.exports = __webpack_public_path__ + "img/android-mask.48bc2da8.svg";